import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const submitNotify = (email) => axios.post(`${API}/notify`, { email });

// DriveClear Public API via server-side proxy (key stays server-side; payloads never in URLs)
const dc = (endpoint, payload) => axios.post(`${API}/dc/${endpoint}`, payload);
export const dcLoan = (p) => dc("loan", p);
export const dcPayment = (p) => dc("payment", p);
export const dcAffordability = (p) => dc("affordability", p);
export const dcDti = (p) => dc("dti", p);
export const dcCostOfOwnership = (p) => dc("cost-of-ownership", p);
export const dcFit = (p) => dc("fit", p);
export const dcHandoff = (p) => dc("handoff", p);

export function friendlyCalcError(err) {
  const status = err?.response?.status;
  if (status === 422) return "One of the values looks out of range — please check the highlighted fields and try again.";
  if (status === 429) return "Lots of calculations right now — give it a moment and try again.";
  return "The calculation service is unavailable right now. Please try again shortly.";
}
